import {
  BillingInterval,
  PlanPackageDetails,
  SimplePlanPackageDetails,
} from "features/types";

// returns the primary component's plan type
export const getPlanType = (
  planPackage: PlanPackageDetails | SimplePlanPackageDetails
) => {
  return planPackage.primaryComponent.type;
};

export const billingIntervalDisplayValue = (
  billingInterval: BillingInterval
) => {
  return billingInterval === "MONTHLY" ? "Monthly" : "Full Season";
};

export const getEmailValidation = (
  planPackage: PlanPackageDetails | undefined | null
) => {
  if (!planPackage) {
    return undefined;
  }
  const emailValidation = planPackage.validations.filter(
    (validation) => validation.type === "EMAIL"
  )[0];
  if (emailValidation) {
    return emailValidation;
  }
  return undefined;
};
